import { NotificationEntitiesType } from '@notifications/models/notification-entities-type';
import { NotificationStatus } from '@notifications/models/notification-status';
import { NotificationType } from '@notifications/models/notification-type';

export const ALL_ITEMS_EXCEL_EXPORT_NOTIFICATIONS: NotificationEntitiesType = {
  [NotificationType.AllItemsExcelExport]: {
    messages: {
      [NotificationStatus.InProgress]: {
        title: 'Generating Export',
        message: 'All items data is being exported to Excel'
      },
      [NotificationStatus.Completed]: {
        title: 'Export complete',
        message: 'All items data is available for download'
      },
      [NotificationStatus.Failed]: {
        title: 'Export failed',
        message: 'Exporting all items data to Excel failed'
      },
      [NotificationStatus.Unavailable]: {
        title: 'Connectivity issues',
        message: 'All items data status unknown, retrying'
      }
    },
    label: 'Download Excel'
  }
};
